<template>
    <v-app>
        <Drawer current_item="menu_automessage"></Drawer>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
export default {
  components: {
    Drawer
  },
  mounted : function () {
    this.$store.getters.getStationList
    .then(result=>{
      if(result.length==0){
        this.$router.push({name:'Station'}) 
      }else{
        document.location = 'automessage/' + result[0].station_code;
      }
    }).catch(error => {
      this.$router.push({name:'Error',params:error}) 
    })
  } 
}
</script>